module.exports = __webpack_public_path__ + "static/media/appletv-new.1c823095.png";